module.exports = __webpack_public_path__ + "c8716f3d6922064d6af7b0250bc190f4.svg";